import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { CHECK_THE_ENTERED_VALUE, INCONSISTENT_DATA, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { baseSocialeCkHelper, getBaseSocialeControl } from './helpers/base-sociale-form.helper';

export const baseSocialeSociSpecialiRules: FormGroupRules = {
    my_SociSpecData: (form: FormGroup) => {
        const my_SociSpecDataControl = getBaseSocialeControl(form, 'my_SociSpecData');
        const my_SociSpecData = toNum(my_SociSpecDataControl?.value);
        const my_SociSpecData_personeFisiche = toNum(getBaseSocialeControl(form, 'my_gr0001.my_SociSpecData_personeFisiche')?.value);
        const errors = my_SociSpecDataControl.errors ? my_SociSpecDataControl.errors : {};

        addRemoveError(my_SociSpecData_personeFisiche > my_SociSpecData, errors, 'my_SociSpecData', {
            status: INCONSISTENT_DATA,
            message: 'Attenzione i soci speciali persone fisiche sono maggiori dei soci speciali totali',
        });

        addRemoveError(!isNilOrEmpty(my_SociSpecData) && my_SociSpecData < 0, errors, 'my_SociSpecData', {
            status: CHECK_THE_ENTERED_VALUE,
        });

        addRemoveError(isNilOrEmpty(my_SociSpecData), errors, 'my_SociSpecData', {
            status: REQUIRED_STATUS,
        });

        my_SociSpecDataControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SociSpecData_personeFisiche: (form: FormGroup) => {
        const my_SociSpecData_personeFisicheControl = getBaseSocialeControl(form, 'my_gr0001.my_SociSpecData_personeFisiche');
        const my_SociSpecData_personeFisiche = toNum(my_SociSpecData_personeFisicheControl?.value);
        const my_SociSpecData = toNum(getBaseSocialeControl(form, 'my_SociSpecData')?.value);
        const errors = my_SociSpecData_personeFisicheControl.errors ? my_SociSpecData_personeFisicheControl.errors : {};

        addRemoveError(my_SociSpecData_personeFisiche > my_SociSpecData, errors, 'my_SociSpecData', {
            message: INCONSISTENT_DATA,
            status: 'Attenzione i soci speciali persone fisiche sono maggiori dei soci speciali totali',
        });

        addRemoveError(!isNilOrEmpty(my_SociSpecData_personeFisiche) && my_SociSpecData_personeFisiche < 0, errors, 'my_SociSpecData', {
            status: CHECK_THE_ENTERED_VALUE,
        });

        addRemoveError(my_SociSpecData > 0 && isNilOrEmpty(my_SociSpecData_personeFisiche), errors, 'my_SociSpecData', {
            status: REQUIRED_STATUS,
        });

        my_SociSpecData_personeFisicheControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSociSpecLimite: (form: FormGroup) => {
        const my_CkSociSpecLimiteControl = getBaseSocialeControl(form, 'my_CkSociSpecLimite');
        const my_SociSpecData = toNum(getBaseSocialeControl(form, 'my_SociSpecData')?.value);
        const errors = my_CkSociSpecLimiteControl.errors ? my_CkSociSpecLimiteControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkSociSpecLimiteControl?.value) && my_SociSpecData > 0, errors, 'my_CkSociSpecLimite', {
            status: REQUIRED_STATUS,
        });

        my_CkSociSpecLimiteControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSociSpecDiritti: (form: FormGroup) => {
        const my_CkSociSpecDirittiControl = getBaseSocialeControl(form, 'my_CkSociSpecDiritti');
        const my_SociSpecData = toNum(getBaseSocialeControl(form, 'my_SociSpecData')?.value);
        const errors = my_CkSociSpecDirittiControl.errors ? my_CkSociSpecDirittiControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkSociSpecDirittiControl?.value) && my_SociSpecData > 0, errors, 'my_CkSociSpecDiritti', {
            status: REQUIRED_STATUS,
        });

        my_CkSociSpecDirittiControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_SocSpecNota: (form: FormGroup) => {
        const my_SocSpecNotaControl = getBaseSocialeControl(form, 'my_SocSpecNota');
        const my_CkSociSpecLimite = toNum(getBaseSocialeControl(form, 'my_CkSociSpecLimite')?.value);
        const my_CkSociSpecDiritti = toNum(getBaseSocialeControl(form, 'my_CkSociSpecDiritti')?.value);
        const errors = my_SocSpecNotaControl.errors ? my_SocSpecNotaControl.errors : {};

        addRemoveError(isNilOrEmpty(my_SocSpecNotaControl?.value) && (my_CkSociSpecLimite === 0 || my_CkSociSpecDiritti === 0), errors, 'my_SocSpecNota', {
            status: REQUIRED_STATUS,
        });

        my_SocSpecNotaControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_DescRuoloSocNoAttSoc: (form: FormGroup) => {
        baseSocialeCkHelper(form, 'my_DescRuoloSocNoAttSoc', 'my_gruppo17.my_ckSoggLibrSociNoAttSociali', 1);
    },

    my_SpecProcedConforme: (form: FormGroup) => {
        baseSocialeCkHelper(form, 'my_SpecProcedConforme', 'my_CkProcedConforme', 0);
    },

    my_SpecReqSociCoerenti: (form: FormGroup) => {
        baseSocialeCkHelper(form, 'my_SpecReqSociCoerenti', 'my_CkReqSociCoerenti', 0);
    },
};
